import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ElementRef,
  Renderer2,
  OnDestroy,
  ViewChild,
  SecurityContext,
} from '@angular/core'
import { BulkServiceService } from '../bulk-service.service'
import { CommonService } from '../../../shared/services/common.service'
import {
  AuthService,
  GlobalMessageService,
  GlobalMessageType,
  TranslationService,
} from '@spartacus/core'
import { ActiveCartFacade, MultiCartFacade } from '@spartacus/cart/base/root'
import { Observable, Subscription } from 'rxjs'
import { Router } from '@angular/router'
import { LaunchDialogService } from '@spartacus/storefront'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { Actions, ofType } from '@ngrx/effects'
import { filter, take } from 'rxjs/operators'
import { QuoteCartService } from '../../quote/quote-services/quote-cart.service'
import { CheckoutService } from '../../cart/checkout/checkout/checkout.service'
import { DomSanitizer } from '@angular/platform-browser'
import { CartActions } from '@spartacus/cart/base/core'
import { OccCartAdapter } from '@spartacus/cart/base/occ'
import moment from 'moment'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../config/dialog.config'
import { SpinnerOverlayService } from '../../../shared/components/spinner-overlay/spinner-overlay.service'
import {
  ACCESSIBILITY,
  UserRoleService,
} from '../../../shared/services/user-role.service'
import { CalenderConfigService } from '../../../shared/services/calender-config.service'
import { QuoteCartFacade } from '../../cart/mini-cart/store/mini-quote-cart.facade'

@Component({
  standalone: false,
  selector: 'vs-bulk-table',
  templateUrl: './bulk-table.component.html',
  styleUrls: ['./bulk-table.component.scss'],
})
export class BulkTableComponent implements OnInit, OnDestroy {
  public responseSuccessData: any
  public responseFailureData: any
  public bulkOrderList
  public hasData: boolean = false
  public bulkFailure
  public checkFailure: boolean = false
  public checkLengthFailure: boolean = false
  public checkFail: boolean = true
  public disbledBtn: boolean = false
  public bulkSuccess
  public bulkFail
  public disableBtn: boolean = false
  public getBulkListUploadObj
  public showErrorParts: boolean = false
  public getBulkUploadObj$: Observable<any> = this.bulkService.getBulkCode()
  public getBulkUploadObj = null
  public getBulkUploadObjFail
  public getHideValue
  public bulkSuccessText = 'BULKSUCCESSTEXT'
  client: any = { indeterminated: false, checked: false }
  isMasterSel: boolean = false
  public bulkFailText = 'BULKFAILTEXT'
  bulkSEntryObjArray: any
  bulkSsEntryObjArray: any
  countNUm: any
  countFail: any
  rfqCartId
  userType: string
  loggedIn: boolean
  getHideFlag
  public successLen
  bulkQuantity: FormGroup = new FormGroup({})
  bulkQuantityFailure: FormGroup = new FormGroup({})
  public failLen
  public sendCartObj
  public cartId
  public quotecartId
  public successArry = []
  public failArry = []
  public minDate = new Date()
  public bulkErrorNumber = ''
  public hideTop: boolean = true
  public selectedItem = []
  sapQuoteId
  @ViewChild('documentClose')
  documentClose: ElementRef
  bulkEntryObj = {
    brandCode: 'Masoneilan',
    brandName: 'Masoneilan',
    comment: '',
    customerRequestedDate: new Date(Date.now())
      .toISOString()
      .slice(0, 19)
      .replace(/-/g, '/')
      .split('T')[0],
    productType: '',
    quantity: 1,
    reasonForQuote: '',
    rfqPartDescription: '',
    rfqPartNumber: 233,
  }
  listener
  pageScrollDownLimit: any = false
  reasonForQuote: any
  showMoveToSuccessBtn: any
  showValidateBtn: any
  public showDate: boolean
  public showFileType: string
  public fileType: string
  accessibility = ACCESSIBILITY
  successArrayCount: any
  filterWeekend = this.calenderConfigService.isFilterWeekend()
  cart: any
  checkoutGetCartSubscription: Subscription
  fileTypeSubscription: Subscription
  newCartIdGenrate: Subscription
  quoteCartEntries: any
  cartTotalItems: any
  qtyFlag: boolean = true
  bulkQuoteCartIdGenrate: Subscription
  qtyFlagFailure: boolean = true
  brandList: any
  isQuoteOrderChecked: boolean = true
  isQuoteOrderDisabled: boolean = false
  bulkSubmitCheck: any
  tableBulkOrder: Subscription
  allRequestedShipDate: any
  isAllRSDapply: boolean = false
  cartCount = {
    OrderCount: 0,
    QuoteCount: 0
  };

  constructor(
    private cdr: ChangeDetectorRef,
    public commonService: CommonService,
    private router: Router,
    private auth: AuthService,
    private globalMessageService: GlobalMessageService,
    protected launchDialogService: LaunchDialogService,
    private bulkService: BulkServiceService,
    private renderer: Renderer2,
    private multiCartFacade: MultiCartFacade,
    private quoteCartFacade: QuoteCartFacade,
    public spinnerOverlayService: SpinnerOverlayService,
    protected cartService: ActiveCartFacade,
    private formBuilder: FormBuilder,
    private actions$: Actions,
    private quoteService: QuoteCartService,
    private userRoleService: UserRoleService,
    private calenderConfigService: CalenderConfigService,
    private checkoutService: CheckoutService,
    private occAdapter: OccCartAdapter,
    private translate: TranslationService,
    private domSanitizer: DomSanitizer
  ) {
    this.bulkService.showDateEmitted$.subscribe((res) => {
      this.showDate = res
    })
    this.bulkService.showFileTypeEmitted$.subscribe((res) => {
      this.showFileType = res
      if (this.showFileType == 'csv') this.fileType = 'CSV'
      else this.fileType = 'EXL'
    })
  }

  dateChangeAll(event) {
    this.allRequestedShipDate = moment(event).format('YYYY/MM/DD');    
    this.cdr.detectChanges();
    this.isAllRSDapply = false;
  }

  applyReqShipDateAll(){
    if(!this.allRequestedShipDate){
      this.isAllRSDapply = true;
      this.globalMessageService.add(
        { key: 'bulkorder.selectCRDErrMsgAll' },
        GlobalMessageType.MSG_TYPE_ERROR,
        7000
      )
      window.scrollTo(0, 0)
    } else{
      this.isAllRSDapply = false;
      const checkedData = this.responseSuccessData.filter(res=> res.selected);

      if(checkedData.length == 0){
        this.globalMessageService.add(
          { key: 'bulkorder.productsSelectErrMsg' },
          GlobalMessageType.MSG_TYPE_ERROR,
          7000
        )
        window.scrollTo(0, 0)
      } else{
        this.responseSuccessData.map((res)=> {
          if(res.selected){
            res.requestedShipDate = this.allRequestedShipDate;
          }
        });
      }
    }
  }

  dateChange(event, j) {   
    this.responseSuccessData[j].requestedShipDate = moment(event).format('YYYY/MM/DD');
    this.cdr.detectChanges();
  }
  dateChangeValidate(event, index) {
    var newData = event
      .toISOString()
      .slice(0, 19)
      .replace(/-/g, '/')
      .split('T')[0]
    let paramDate = newData.split('/')
    let newDate =
      paramDate[0] + '/' + paramDate[1] + '/' + (parseInt(paramDate[2]) + 1)

    let dateToday = new Date()
    let dateTodayForCompare = new Date(dateToday)
    let dateToCompare = new Date(newDate)
    this.responseFailureData[index].requestedShipDate = newDate
    this.responseFailureData[index]?.errorMessage?.entry.forEach((element) => {
      if (element.key == 'dateFormat') {
        this.responseFailureData[index]?.errorMessage?.entry.splice(
          this.responseFailureData[index]?.errorMessage?.entry.indexOf(element),
          1
        )
        this.showValidateBtn = true
      } else {
        this.showValidateBtn = false
      }
    })
    if (this.responseFailureData[index]?.errorMessage?.entry.length > 0) {
      this.showValidateBtn = false
    }
    if (dateToCompare.toString().includes('Invalid Date')) {
      this.responseFailureData[index].requestedShipDateStatus = true
    } else {
      if (dateTodayForCompare > dateToCompare) {
        this.responseFailureData[index].requestedShipDateStatus = true
      } else {
        this.responseFailureData[index].requestedShipDateStatus = false
      }
    }
    this.cdr.detectChanges()
  }

  closeErrorSection() {
    if (this.documentClose !== undefined) {
      this.renderer.setStyle(
        this.domSanitizer.sanitize(
          SecurityContext.NONE,
          this.documentClose.nativeElement
        ),
        'display',
        'none'
      )
    }
  }
  removeProductSuccess(j) {
    this.successArrayCount = 0
    this.responseSuccessData[j].isDeleted = true
    this.responseSuccessData[j].isDeleted = true
    // event.target.parentNode.parentNode.innerHTML = '';
    this.responseSuccessData.forEach((element) => {
      if (!element?.isDeleted) {
        this.successArrayCount++
      }
    })
    if (
      this.selectedItem?.length == this.successArrayCount &&
      this.selectedItem?.length > 0
    ) {
      this.client.indeterminated = false
      this.client.checked = true
      this.isMasterSel = true
    }
  }
  removeProductFailure(p) {
    this.responseFailureData[p].isDeleted = true
  }
  openFailure() {
    this.showErrorParts = true
    this.closeErrorSection()
  }

  checkCartStatus(orderFlag?: any) {
    this.cartCount = {
      OrderCount: 0,
      QuoteCount: 0
    };

    this.responseSuccessData.filter((item)=>{
      if(item.selected && !item.isDeleted && item.isChecked){
        this.cartCount.OrderCount = this.cartCount.OrderCount + 1;
      } else if(item.selected && !item.isDeleted && !item.isChecked){
        this.cartCount.QuoteCount = this.cartCount.QuoteCount + 1;
      }
    });
    
    if(this.cartCount.OrderCount > 0){
      this.checkBuyCartStatus(orderFlag, this.cartCount);
    } else{
      this.callQuote(orderFlag, false);
    }
  }

  checkBuyCartStatus(orderFlag?: any, cartCount?: any){
    const urlparams = ['users', this.userType, 'carts', this.cartId, 'count']
    const apiUrl = this.commonService.constructUrl(urlparams)
    this.spinnerOverlayService.show()
    this.commonService.getData(apiUrl).subscribe(
      (success: any) => {
        this.bulkService.newCartId.next(false)
        this.cartTotalItems = success.cartSize
        this.sapQuoteId = success.sapQuoteId
        let entriesCount
        if (this.successArrayCount > 0)
          entriesCount =
            this.cartTotalItems +
            (cartCount.OrderCount -
              (cartCount.OrderCount - this.successArrayCount))
        else
          entriesCount = this.cartTotalItems + cartCount.OrderCount

        if (entriesCount > 150) {
          this.spinnerOverlayService.hide()
          let removeCount = entriesCount - 150
          let errorMsg
          if (this.cartTotalItems == 150) errorMsg = 'bulkorder.maxShopLimit'
          else errorMsg = 'bulkorder.maxShopLimit2'
          this.globalMessageService.add(
            {
              key: errorMsg,
              params: {
                removeCountJson: removeCount,
                entryLength: this.cartTotalItems,
              },
            },
            GlobalMessageType.MSG_TYPE_ERROR,
            7000
          )
          window.scrollTo(0, 0)
          return
        } else if (this.sapQuoteId) {
          this.multiCartFacade.deleteCart(this.cartId, this.userType)
          this.actions$
            .pipe(ofType(CartActions.DELETE_CART_SUCCESS))
            .pipe(take(1))
            .subscribe((r) => {
              sessionStorage.setItem('quoteCartType', '')
              sessionStorage.setItem('isRfqCart', '')
              this.spinnerOverlayService.hide()
              this.globalMessageService.add(
                { key: 'addCart.existingCartRemoved' },
                GlobalMessageType.MSG_TYPE_ERROR,
                10000
              )
              window.scroll(0, 0)
              this.occAdapter
                .create('current')
                .pipe(take(1))
                .subscribe((occData) => {
                  this.cartId = occData.code
                  sessionStorage.setItem('quoteCartType', '')
                  sessionStorage.setItem('isRfqCart', '')
                  this.postProductsCart()
                  this.multiCartFacade.loadCart({
                    userId: 'current',
                    cartId: this.cartId,
                    extraData: {
                      active: true,
                    },
                  })
                })
            })

          this.actions$
            .pipe(ofType(CartActions.DELETE_CART_FAIL))
            .pipe(take(1))
            .subscribe(
              (r) => {
                this.spinnerOverlayService.hide()
                this.globalMessageService.add(
                  { key: 'bulkorder.clearCartFailed' },
                  GlobalMessageType.MSG_TYPE_ERROR,
                  5000
                )
                window.scrollTo(0, 0)
              },
              (error) => {
                this.globalMessageService.add(
                  error,
                  GlobalMessageType.MSG_TYPE_ERROR,
                  5000
                )
                window.scrollTo(0, 0)
              }
            )
        } else {
          if(cartCount.QuoteCount > 0){
            this.checkQuoteCartStatus(orderFlag, cartCount);
          } else{
            this.spinnerOverlayService.hide();
            this.postProductsCart(orderFlag);
          }
        }
      },
      (error) => {
        this.spinnerOverlayService.hide()
        this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR)
        this.bulkService.newCartId.next(false)
      }
    )
  }

  checkQuoteCartStatus(orderFlag?: any, cartCount?: any) {
    this.quotecartId = sessionStorage.getItem('cartId-' + this.userType)
    this.quoteService
      .getCart(this.quotecartId, this.userType)
      .pipe(take(1))
      .subscribe((success) => {
        this.rfqCartId = success['code']
      })
    const urlparams = [
      'users',
      this.userType,
      'rfqcart',
      this.rfqCartId,
      'count',
    ]
    const apiUrl = this.commonService.constructUrl(urlparams)

    this.commonService.getData(apiUrl).subscribe(
      (success) => {
        this.bulkService.bulkQuoteCartId.next(false)
        this.quoteCartEntries = success
        this.spinnerOverlayService.hide();

        let currentEntries = cartCount.QuoteCount;
        let entriesCount = currentEntries + this.quoteCartEntries
        if (entriesCount > 150) {
          let removeCount = entriesCount - 150
          let errorMsg
          if (this.quoteCartEntries == 150) errorMsg = 'bulkorder.maxQuoteLimit'
          else errorMsg = 'bulkorder.maxQuoteLimit2'
          this.globalMessageService.add(
            {
              key: errorMsg,
              params: {
                removeCountJson: removeCount,
                entryLength: this.quoteCartEntries,
              },
            },
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          return
        } else {
          this.postProductsCart(orderFlag)
        }
      },
      (error) => {
        this.spinnerOverlayService.hide()
      }
    )
  }

  postProductsCart(orderFlag?: any) {
    this.spinnerOverlayService.show('')
    // this.cartService.getActiveCartId().subscribe((cartId) => {
    // this.cartId = cartId;
    let bulkEntryObjSuccessArray = []
    let bulkEntryObjSuccess
    for (var i = 0; i < this.responseSuccessData.length; i++) {
      const checkOrderAll = (orderFlag == 'all') ? (!this.responseSuccessData[i].isDeleted && !this.responseSuccessData[i].isDisabled) : (!this.responseSuccessData[i].isDeleted && this.responseSuccessData[i].isChecked && this.responseSuccessData[i]?.selected)
      if (checkOrderAll) {
        bulkEntryObjSuccess = {
          quantity:
            this.bulkQuantity.get(this.bulkSuccessText + i).value > 9999
              ? 9999
              : this.bulkQuantity.get(this.bulkSuccessText + i).value,
          product: {
            code: this.responseSuccessData[i].partNumber,
          },
          deliveryGroupNumber: this.responseSuccessData[i]?.deliveryGroup,
          comment: this.responseSuccessData[i]?.additionalComments,
          customerRequestedDate: this.responseSuccessData[i].requestedShipDate,
          serialNumber: this.responseSuccessData[i].serialNumber,
          tagNumber: this.responseSuccessData[i].tagNumber,
          customerReference: this.responseSuccessData[i].customerReference,
          lineNumber: this.responseSuccessData[i].lineNumber,
          entryType: this.responseSuccessData[i]?.entryType
        }
        bulkEntryObjSuccessArray.push(bulkEntryObjSuccess)
        //this.responseSuccessData[i].isDeleted = true
      }

      if(orderFlag == 'all' && !this.responseSuccessData[i].isDisabled){
        this.responseSuccessData[i].isChecked = true;
      }
    }

    if(orderFlag == 'all'){
      this.spinnerOverlayService.hide();
      return false;
    }

    const apiParams = {
      orderEntries: bulkEntryObjSuccessArray,
    }
    
    if(bulkEntryObjSuccessArray.length == 0){
      if(this.bulkSubmitCheck === 'submit'){
        this.callQuote(this.bulkSubmitCheck, false);
      } else{
        this.spinnerOverlayService.hide();
      }
    } else{
      const urlparams = [
        'users',
        this.userType,
        'carts',
        this.cartId,
        'bulkUploadEntries',
      ]
      const apiUrl = this.commonService.constructUrl(urlparams)
      return this.commonService.postData(apiUrl, apiParams).subscribe(
        (success) => {
          if (
            success['nonCatalogProductList'] !== undefined &&
            success['nonCatalogProductList'].length > 0
          ) {
            this.bulkService.priceNotAvailableinSAPProducts.next(
              success['nonCatalogProductList']
            )
          }
          const componentdata = {}

          const bulkOrderDialog = this.launchDialogService.openDialog(
            VS_LAUNCH_CALLER.BULK_ORDER,
            undefined,
            undefined,
            componentdata
          )
          if (bulkOrderDialog) {
            bulkOrderDialog.pipe(take(1)).subscribe((value) => {})
            this.launchDialogService.dialogClose
              .pipe(
                filter(
                  (dialogResponse: DialogResponse) =>
                    dialogResponse?.type == VS_LAUNCH_CALLER.BULK_ORDER
                ),
                take(1)
              )
              .subscribe((dialogResponse: DialogResponse) => {
                if (dialogResponse.reason == 'OK') {
                  this.multiCartFacade.loadCart({
                    userId: 'current',
                    cartId: this.cartId,
                    extraData: {
                      active: true,
                    },
                  })
                  this.actions$
                    .pipe(ofType(CartActions.LOAD_CART_SUCCESS))
                    .pipe(take(1))
                    .subscribe(
                      (r) => {
                        this.spinnerOverlayService.hide();
                        this.sendCartObj = success;
                        this.router.navigate(['/cart']);

                        if(this.bulkSubmitCheck === 'submit' && this.cartCount.QuoteCount > 0){
                          this.callQuote(this.bulkSubmitCheck, true);
                        }
                        
                        if (getFailureCount <= 0) {
                          
                        } else {
                          // this.hideSuccessList = false;
                          this.bulkService.getSucFlag.next(false)
                        }
                      },
                      (e) => {
                        this.spinnerOverlayService.hide()
                        this.globalMessageService.add(
                          { key: 'bulkorder.errorOccuredInCart' },
                          GlobalMessageType.MSG_TYPE_ERROR,
                          5000
                        )
                      }
                    )
                }
              })
          }
          let getFailureCount = this.getErrorLength()
        },
        (error) => {
          this.spinnerOverlayService.hide()
        }
      )
    }
    // });
  }

  toggleBulkItems(itemFlag){
    for (var i = 0; i < this.responseSuccessData.length; i++) {
      const checkAll = (itemFlag == 'order') ? (!this.responseSuccessData[i].isDeleted && !this.responseSuccessData[i].isDisabled) : !this.responseSuccessData[i].isDeleted;
      if(itemFlag == 'order' && checkAll){        
        this.responseSuccessData[i].isChecked = true;
      } else if(itemFlag == 'quote' && checkAll){        
        this.responseSuccessData[i].isChecked = false;
      }
    }
  }
  getValaue(k) {
    return Object.values(k)
  }

  unSubscribeBulkOrder(){
    if(this.tableBulkOrder){
      this.tableBulkOrder.unsubscribe();
      this.tableBulkOrder = null;
    }
  }

  tableBulk() {
    this.unSubscribeBulkOrder();

    this.tableBulkOrder = this.bulkService.recieveOrderId.subscribe((res) => {
      if (res !== undefined && res !== null) {
        if (this.showDate) {
          if (this.showFileType == 'csv') {
            this.globalMessageService.add(
              { key: 'bulkorder.csvUploaded' },
              GlobalMessageType.MSG_TYPE_CONFIRMATION,
              8000
            )
          } else if (
            this.showFileType == 'xlsx' ||
            this.showFileType == 'xls'
          ) {
            this.globalMessageService.add(
              { key: 'bulkorder.xlsUploaded' },
              GlobalMessageType.MSG_TYPE_CONFIRMATION,
              8000
            )
          }
        } else if (!this.showDate) {
          this.globalMessageService.add(
            { key: 'bulkorder.productsCheckedSuccessfully' },
            GlobalMessageType.MSG_TYPE_INFO,
            8000
          )
          window.scrollTo(0, 0)
        }
        this.getBulkUploadObj = res
        this.responseSuccessData = res['success']
        this.responseFailureData = res['failure']

        this.responseFailureData.forEach((element, index) => {
          let dateToday = new Date()
          let dateTodayForCompare = new Date(dateToday)
          let dateToCompare = new Date(element.requestedShipDate)

          if (dateToCompare.toString().includes('Invalid Date')) {
            this.responseFailureData[index].requestedShipDateStatus = true
          } else {
            if (dateTodayForCompare > dateToCompare) {
              this.responseFailureData[index].requestedShipDateStatus = true
            } else {
              this.responseFailureData[index].requestedShipDateStatus = false
            }
          }

          if(!res._hasMergedFailures){
            this.responseSuccessData.push(element);
          }

          // const matchedParts = this.responseSuccessData.find(part=>part.partNumber === element.partNumber && part.errorMessage)
          // if(!matchedParts){
          //   this.responseSuccessData.push(element)
          // }
        })

        res._hasMergedFailures = true;
        // this.bulkSuccess = this.getBulkUploadObj['success'];
        this.countNUm = res['success'].length
        var k = 0
        this.responseSuccessData.forEach((productItem) => {
          productItem.isDeleted = false
          productItem.isDisabled = productItem.errorMessage ? true : false
          productItem.isChecked = productItem.errorMessage ? false : true
          productItem.selected = false
          this.loadSuccessQunatity(productItem, k)
          k++
        })
        var v = 0
        this.responseFailureData.forEach((element) => {
          element.isDeleted = false
          this.loadFailureQuantity(element, v)
          v++
        })
        if (this.countNUm <= 0) {
          this.disableBtn = true
        }
        this.countFail = res['failure'].length
        this.bulkService.sendSuccessArr(this.responseSuccessData)
        this.bulkService.sendFailureCount(this.countFail)
        if (this.countFail < 0) {
          this.checkLengthFailure = true
        } else {
          this.checkLengthFailure = false
        }

        this.bulkSEntryObjArray = []
        let bulkCEntryObj = {}
        for (let productItem of this.responseSuccessData) {
          productItem.isDeleted = false
          bulkCEntryObj = {
            partName: productItem.partName,
            partNumber: productItem.partNumber,
            quantity: productItem.quantity,
            customerRequestedDate: productItem.requestedShipDate,
            deliveryGroupNumber: productItem?.deliveryGroup,
            comment: productItem?.additionalComments,
          }
          this.bulkSEntryObjArray.push(bulkCEntryObj)
        }

        this.bulkSsEntryObjArray = []
        let bulkCssEntryObj = {}
        for (let productItem of this.responseFailureData) {
          productItem.isDeleted = false
          bulkCssEntryObj = {
            partName: productItem.partName,
            partNumber: productItem.partNumber,
            quantity: productItem.quantity,
            customerRequestedDate: productItem.requestedShipDate,
            deliveryGroupNumber: productItem?.deliveryGroup,
            comment: productItem?.additionalComments,
          }
          this.bulkSsEntryObjArray.push(bulkCssEntryObj)
        }
      }
    })
  }

  createBulkTable(renderedList, parentId, type) {
    let appendDiv = this.domSanitizer.sanitize(
      SecurityContext.NONE,
      document.getElementById(parentId)
    )
    let _this = this
    if (renderedList.length > 0) {
      for (var i = 0; i < renderedList.length; i++) {
        let bulkTr = this.domSanitizer.sanitize(
          SecurityContext.NONE,
          this.renderer.createElement('tr')
        )
        let bulkTd = this.renderer.createElement('td')
        if (type == 'failure') {
          let input = this.domSanitizer.sanitize(
            SecurityContext.NONE,
            this.renderer.createElement('input')
          )
          this.renderer.setAttribute(
            input,
            'value',
            this.domSanitizer.sanitize(
              SecurityContext.NONE,
              renderedList[i].partNumber
            )
          )
          let errorMsg = this.renderer.createElement('p')
          errorMsg.innerText = this.domSanitizer.sanitize(
            SecurityContext.NONE,
            renderedList[i].errorMessage.entry[0].value
          )
          this.renderer.setAttribute(input, 'class', 'error')
          this.renderer.setAttribute(errorMsg, 'class', 'error-msg')
          this.renderer.appendChild(
            this.domSanitizer.sanitize(SecurityContext.NONE, bulkTd),
            input
          )
          this.renderer.appendChild(
            this.domSanitizer.sanitize(SecurityContext.NONE, bulkTd),
            errorMsg
          )
        } else {
          bulkTd.innerText = renderedList[i].partNumber
        }
        this.renderer.appendChild(appendDiv, bulkTr)
        this.renderer.appendChild(
          bulkTr,
          this.domSanitizer.sanitize(SecurityContext.NONE, bulkTd)
        )
        let bulkTdOne = this.renderer.createElement('td')
        this.renderer.setAttribute(
          this.domSanitizer.sanitize(SecurityContext.NONE, bulkTd),
          'class',
          'text-body'
        )

        let bulkTdTwo = this.renderer.createElement('td')
        let bulkTdThree = this.renderer.createElement('td')
        let bulkTdFour = this.domSanitizer.sanitize(
          SecurityContext.NONE,
          this.renderer.createElement('td')
        )

        let deleteIcon = this.renderer.createElement('i')

        let deleteText = this.renderer.createText('delete')
        this.renderer.appendChild(
          this.domSanitizer.sanitize(SecurityContext.NONE, deleteIcon),
          this.domSanitizer.sanitize(SecurityContext.NONE, deleteText)
        )
        this.renderer.appendChild(
          bulkTr,
          this.domSanitizer.sanitize(SecurityContext.NONE, bulkTdOne)
        )
        this.renderer.appendChild(
          bulkTr,
          this.domSanitizer.sanitize(SecurityContext.NONE, bulkTdTwo)
        )
        this.renderer.appendChild(
          bulkTr,
          this.domSanitizer.sanitize(SecurityContext.NONE, bulkTdThree)
        )
        this.renderer.appendChild(bulkTr, bulkTdFour)
        this.renderer.appendChild(
          bulkTdFour,
          this.domSanitizer.sanitize(SecurityContext.NONE, deleteIcon)
        )
        this.renderer.setAttribute(bulkTr, 'class', 'heading-body')
        this.renderer.setAttribute(bulkTdOne, 'class', 'text-body')
        this.renderer.setAttribute(bulkTdTwo, 'class', 'text-body')
        this.renderer.setAttribute(bulkTdThree, 'class', 'text-body')
        this.renderer.setAttribute(bulkTdFour, 'class', 'text-body')

        bulkTdOne.innerText = renderedList[i].partName
        bulkTdTwo.innerText = renderedList[i].quantity
        bulkTdThree.innerText = renderedList[i].requestedShipDate

        this.renderer.setAttribute(
          this.domSanitizer.sanitize(SecurityContext.NONE, deleteIcon),
          'class',
          'material-icons custom-delete'
        )
        this.renderer.setAttribute(
          this.domSanitizer.sanitize(SecurityContext.NONE, deleteIcon),
          'id',
          `${i}`
        )
        deleteIcon.addEventListener('click', function (evt) {
          this.parentElement.parentElement.remove()
        })
      }
    }
  }
  loadFailures() {
    return new Promise<void>((resolve, reject) => {
      this.openFailure()
      resolve()
    })
  }
  callQuote(bulkFlag: any, isOrder?: any) {
    this.quotecartId = sessionStorage.getItem('cartId-' + this.userType)
    this.bulkSubmitCheck = bulkFlag
    this.quoteService
      .getCart(this.quotecartId, this.userType)
      .pipe(take(1))
      .subscribe((success) => {
        this.rfqCartId = success['code']
      })
    const urlparams = [
      'users',
      this.userType,
      'rfqcart',
      this.rfqCartId,
      'count',
    ]
    const apiUrl = this.commonService.constructUrl(urlparams)

    if (!this.spinnerOverlayService.getOverlayRef()) {
      this.spinnerOverlayService.show()
    }

    return this.commonService.getData(apiUrl).subscribe(
      (success) => {
        this.bulkService.bulkQuoteCartId.next(false)
        this.quoteCartEntries = success
        this.spinnerOverlayService.hide()
        this.loadFailures().then((res) => this.goToQuoteConfirm(bulkFlag, isOrder))
      },
      (error) => {
        this.spinnerOverlayService.hide()
      }
    )
  }
  goToQuoteConfirm(bulkFlag, isOrder) {
    if (this.showErrorParts) {
      this.spinnerOverlayService.show()
      let bulkEntryObjArray = []
      let bulkEntryObj
      let filterRecord
      let brandObj
      for (var i = 0; i < this.responseSuccessData.length; i++) {
        filterRecord = this.reasonForQuote?.filter(
          (element) =>
            element.name == this.responseSuccessData[i]?.reasonForQuote
        )
        brandObj = this.brandList?.filter(
          (element) => element.name == this.responseSuccessData[i]?.brandName
        )

        let bulkSubmit = (bulkFlag == 'all') ? (!this.responseSuccessData[i].isDeleted) : (!this.responseSuccessData[i].isDeleted && !this.responseSuccessData[i].isChecked && this.responseSuccessData[i]?.selected);

        if(bulkFlag == 'all'){
          this.responseSuccessData[i].isChecked = false; 
        }

        if (bulkSubmit) {
          bulkEntryObj = {
            brandCode: brandObj[0]?.code ? brandObj[0]?.code : '',
            brandName: this.responseSuccessData[i]?.brandName
              ? this.responseSuccessData[i]?.brandName
              : '',
            serialNumber: this.responseSuccessData[i]?.serialNumber,
            customerRequestedDate: this.responseSuccessData[i]?.requestedShipDate,
            productType: this.responseSuccessData[i]?.productType || '',
            quantity:
              this.bulkQuantity.get(this.bulkSuccessText + i).value > 9999
                ? 9999
                : this.bulkQuantity.get(this.bulkSuccessText + i).value,
            reasonForQuote: filterRecord[0]?.code
              ? filterRecord[0]?.code
              : this.reasonForQuote[0]?.code,
            rfqPartDescription: this.responseSuccessData[i]?.partName,
            rfqPartNumber: this.responseSuccessData[i]?.partNumber,
            comment: this.responseSuccessData[i]?.additionalComments,
            tagNumber: this.responseSuccessData[i]?.tagNumber,
            isUnsolicited: this.responseSuccessData[i]?.isUnsolicited,
            lineNumber: this.responseSuccessData[i]?.lineNumber,
            customerReferenceNumber: this.responseSuccessData[i]?.customerReference,
            entryType: this.responseSuccessData[i]?.entryType
          }
          bulkEntryObjArray.push(bulkEntryObj)
        }
      }

      if(bulkFlag == 'all'){
        this.spinnerOverlayService.hide();
        return false;
      }

      const apiParams = {
        quoteEntryList: bulkEntryObjArray,
      }
      const urlparams = [
        'users',
        this.userType,
        'rfqcart',
        this.rfqCartId,
        'bomRfqEntries',
      ]
      const apiUrl = this.commonService.constructUrl(urlparams)
      let currentEntries = apiParams.quoteEntryList.length
      let entriesCount = currentEntries + this.quoteCartEntries
      if (entriesCount > 150) {
        this.spinnerOverlayService.hide();
        let removeCount = entriesCount - 150
        let errorMsg
        if (this.quoteCartEntries == 150) errorMsg = 'bulkorder.maxQuoteLimit'
        else errorMsg = 'bulkorder.maxQuoteLimit2'
        this.globalMessageService.add(
          {
            key: errorMsg,
            params: {
              removeCountJson: removeCount,
              entryLength: this.quoteCartEntries,
            },
          },
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        return
      } else {
        return this.commonService.postData(apiUrl, apiParams).subscribe(
          (success) => {
            sessionStorage.setItem('cartStatus-' + this.userType, 'added')
            this.quoteCartFacade.loadCart();
            //this.spinnerOverlayService.hide();

            if(bulkFlag != 'submit' || !isOrder)
            this.router.navigate(['/quote/cart'])
          },
          (error) => {
            this.spinnerOverlayService.hide()
          }
        )
      }
    }
  }

  bulkSubmitAll(){
    const checkedData = this.responseSuccessData.filter(res=> res.selected && !res.isDeleted);
    if(checkedData.length > 0){
      const CRDdateSelected = checkedData.filter(res=> res.requestedShipDate && !res.isDeleted);

      if(CRDdateSelected.length != checkedData.length){
        this.globalMessageService.add(
          { key: 'bulkorder.selectCRDErrMsg' },
          GlobalMessageType.MSG_TYPE_ERROR,
          7000
        )
      } else {
        this.bulkSubmitCheck = 'submit';
        this.checkCartStatus('submit');
      }
    } else{
      this.globalMessageService.add(
        { key: 'bulkorder.productsSelectErrMsg' },
        GlobalMessageType.MSG_TYPE_ERROR,
        7000
      )
      window.scrollTo(0, 0)
    }    
  }

  demo() {
    this.spinnerOverlayService.show('')
    // setTimeout(function(){
    this.hideLoader()
    // },3000);
  }

  hideLoader() {
    this.spinnerOverlayService.hide()
  }

  goToTop() {
    //  this.spinnerOverlayService.show();
    // this.one(this.two)

    // window.setTimeout(() => {
    //   this.spinnerOverlayService.show();
    // }, 100);
    window.scroll({ top: 0, left: 0, behavior: 'smooth' })

    // window.setTimeout(() => {
    //   this.spinnerOverlayService.hide();
    // }, 5000);
  }

  ngOnInit(): void {
    this.getHideFlag = true
    this.auth.isUserLoggedIn().subscribe((success) => {
      if (success) {
        this.rfqCartId = sessionStorage.getItem('cartId-current')
      } else {
        this.rfqCartId = sessionStorage.getItem('cartId-anonymous')
      }
    })

    this.auth.isUserLoggedIn().subscribe((success) => {
      if (success) {
        this.loggedIn = true
        this.userType = 'current'
      } else {
        this.loggedIn = false
        this.userType = 'anonymous'
      }
    })
    this.cartService.getActiveCartId().subscribe((data) => {
      this.cartId = data
    })

    this.newCartIdGenrate = this.bulkService.newCartId.subscribe(
      (newCartId) => {
        if (newCartId) {
          this.checkCartStatus()
        }
      }
    )

    this.bulkQuoteCartIdGenrate = this.bulkService.bulkQuoteCartId.subscribe(
      (bulkQuoteCartId) => {
        if (bulkQuoteCartId) {
          this.callQuote('all')
        }
      }
    )

    this.quoteService
      .getQuoteReason(this.userType)
      .subscribe((success: any) => {
        this.reasonForQuote = success.reasonforQuote
      })
    this.quoteService.getBrand(this.userType, this.cartId).subscribe(
      (success) => {
        this.brandList = success
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
    this.listener = this.renderer.listen('window', 'scroll', (e) => {
      if (window.pageYOffset < 200) {
        this.pageScrollDownLimit = false
      } else {
        this.pageScrollDownLimit = true
      }
    })

    this.tableBulk()
    this.bulkService.priceNotAvailableinSAPProducts.next([])
  }
  ngOnDestroy() {
    if (this.checkoutGetCartSubscription) {
      this.checkoutGetCartSubscription.unsubscribe()
    }
    if (this.newCartIdGenrate) {
      this.newCartIdGenrate.unsubscribe()
    }
    if (this.bulkQuoteCartIdGenrate) {
      this.bulkQuoteCartIdGenrate.unsubscribe()
    }
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR)
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_WARNING)
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_INFO)
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_CONFIRMATION)
    this.bulkService.getSucFlag.next(true)
    this.bulkService.showFileType.next(null)
    this.listener()
    this.unSubscribeBulkOrder();
  }

  slideToggle(e, toggleData){
    toggleData.isChecked = e.checked;
  }

  loadSuccessQunatity(i, j) {
    this.bulkQuantity.addControl(
      this.bulkSuccessText + j,
      new FormControl(i.quantity || 1, Validators.required)
    )
  }
  loadFailureQuantity(i, j) {
    this.bulkQuantityFailure.addControl(
      this.bulkFailText + j,
      new FormControl(i.quantity || 1, Validators.required)
    )
  }
  onProductQtyIncrement(product) {
    product.quantity++
  }

  onProductQtyDecrement(product) {
    product.quantity--
  }
  increaseQuantity(value, i) {
    this.qtyFlag = false
  }
  decreaseQuantity(value, i) {
    this.qtyFlag = false
  }
  increaseQuantityFailure(value, i) {
    this.qtyFlagFailure = false
  }
  decreaseQuantityFailure(value, i) {
    this.qtyFlagFailure = false
  }
  search(partnumber, index) {
    this.quoteService.searchProduct(partnumber).subscribe((success: any) => {
      if (
        this.loggedIn &&
        success?.products.length === 1 &&
        !success?.products[0].obsoleteProductFlag &&
        success?.products[0].sellabilityFlag &&
        partnumber == success?.products[0].code
      ) {
        this.responseFailureData[index].partName = success?.products[0].name
        this.showValidateBtn = this.bulkFailText + index
        this.responseFailureData[index]?.errorMessage?.entry.forEach(
          (element) => {
            if (element.key != 'dateFormat') {
              this.responseFailureData[index]?.errorMessage?.entry.splice(
                this.responseFailureData[index]?.errorMessage?.entry.indexOf(
                  element
                ),
                1
              )
            }
          }
        )
        return this.bulkFailText + index
      } else if (
        !this.loggedIn &&
        success?.products.length === 1 &&
        !success?.products[0].obsoleteProductFlag &&
        partnumber == success?.products[0].code
      ) {
        this.responseFailureData[index].partName = success?.products[0].name
        this.showValidateBtn = this.bulkFailText + index
        this.responseFailureData[index]?.errorMessage?.entry.forEach(
          (element) => {
            if (element.key != 'dateFormat') {
              this.responseFailureData[index]?.errorMessage?.entry.splice(
                this.responseFailureData[index]?.errorMessage?.entry.indexOf(
                  element
                ),
                1
              )
            }
          }
        )
        return this.bulkFailText + index
      }
    })
  }
  saveDataInfailure(i, p) {
    this.responseFailureData[p] = i
    this.loadFailureQuantity(i, p)
    this.cdr.detectChanges()
  }
  saveDataInSuccess(i, p) {
    var obj = {
      partNumber: i.partNumber,
      partName: i.partName,
      quantity: i.quantity,
      requestedShipDate: i.requestedShipDate,
    }
    this.responseSuccessData.push(obj)
    if (this.responseSuccessData.length > 0) {
      this.disableBtn = false
    }
    this.loadSuccessQunatity(
      this.responseSuccessData[this.responseSuccessData.length - 1],
      this.responseSuccessData.length - 1
    )
    this.responseFailureData[p].isDeleted = true
    let errorCount = 0
    this.spinnerOverlayService.show()
    this.responseFailureData.forEach((element) => {
      if (!element.isDeleted) {
        errorCount++
        return
      }
    })
    if (errorCount == 0) {
      this.showErrorParts = false
      this.spinnerOverlayService.hide()
    } else {
      this.spinnerOverlayService.hide()
    }
    this.cdr.detectChanges()
  }
  showErrorInPartNumber(i, p) {
    i.errorMessage?.entry.forEach((element) => {
      if (element.key != 'dateFormat') {
        return true
      }
    })
    if (!i.errorMessage) {
      return false
    }
  }

  updateCheckedOptions(event, element, index) {
    this.successArrayCount = 0
    this.responseSuccessData.forEach((element) => {
      if (!element?.isDeleted) {
        this.successArrayCount++
      }
    })
    // this.isMasterSel = false;
    element.selected = event
    element.index = index
    if (element.selected === true) {
      this.client.indeterminated = true
      this.isMasterSel = false
      this.client.checked = false
      this.selectedItem.push(element)
      if (
        this.selectedItem?.length == this.successArrayCount &&
        this.selectedItem?.length > 0
      ) {
        this.client.indeterminated = false
        this.client.checked = true
        this.isMasterSel = true
      }
    } else if (element.selected === false) {
      this.isMasterSel = false
      this.client.checked = false
      this.client.indeterminated = true
      this.selectedItem.forEach((item) => {
        if (item.index === index) {
          this.selectedItem.splice(this.selectedItem.indexOf(item), 1)
        }
      })
      if (this.selectedItem?.length > 0) {
        this.client.checked = false
        this.isMasterSel = false
        this.client.indeterminated = true
      } else {
        this.client.indeterminated = false
      }
      if (
        this.selectedItem?.length == this.successArrayCount &&
        this.selectedItem?.length > 0
      ) {
        this.client.indeterminated = false
        this.client.checked = true
        this.isMasterSel = true
      }
    }
  }
  deleteAll() {
    this.successArrayCount = 0
    for (var i = 0; i < this.selectedItem.length; i++) {
      this.responseSuccessData[this.selectedItem[i]?.index].isDeleted = true
    }
    this.responseSuccessData.forEach((element) => {
      if (!element?.isDeleted) {
        this.successArrayCount++
      }
    })
    this.client.indeterminated = false
    this.client.checked = false
    this.isMasterSel = false
  }
  onMasterClick(cliente: any, event) {
    this.selectedItem = []
    this.isMasterSel = event.target.checked
    cliente.checked = event.target.checked
    cliente.indeterminated = false
    if (this.isMasterSel) {
      for (var i = 0; i < this.responseSuccessData.length; i++) {
        if (!this.responseSuccessData[i]?.isDeleted) {
          this.responseSuccessData[i].selected = this.isMasterSel
          this.responseSuccessData[i].index = i

          this.selectedItem.push(this.responseSuccessData[i])
        }
      }
    } else {
      for (var i = 0; i < this.responseSuccessData.length; i++) {
        if (!this.responseSuccessData[i]?.isDeleted) {
          this.responseSuccessData[i].selected = this.isMasterSel
          this.responseSuccessData[i].index = i
        }
      }
      this.selectedItem = []
    }
  }
  checkUserEnabled(flagName) {
    return this.userRoleService.checkUserRoleEnabled(flagName)
  }
  getSuccessLength() {
    let count = 0
    this.responseSuccessData.forEach((element) => {
      if (!element.isDeleted) {
        count++
      }
    })
    return count
  }
  getErrorLength() {
    let count = 0
    this.responseFailureData.forEach((element) => {
      if (!element.isDeleted) {
        count++
      }
    })
    return count
  }
}
